// Implements the Lyrics panel marker-range rule from Booth handoff plan amendment A12.
export const sectionAtPlayhead = (markers = [], playheadBar = 0, totalBars = 0) => {
  if (!Number.isFinite(playheadBar) || playheadBar < 0 || playheadBar >= totalBars) return null;
  const ordered = [...markers].sort((a, b) => a.startBar - b.startBar);
  const index = ordered.findIndex((marker, markerIndex) => {
    const nextStart = ordered[markerIndex + 1]?.startBar ?? totalBars;
    return playheadBar >= marker.startBar && playheadBar < nextStart;
  });
  return index >= 0 ? ordered[index].id || null : null;
};
